import { render } from "./FintriviaPrizes.vue?vue&type=template&id=14ed6709&scoped=true"
import script from "./FintriviaPrizes.vue?vue&type=script&lang=js"
export * from "./FintriviaPrizes.vue?vue&type=script&lang=js"

import "./FintriviaPrizes.vue?vue&type=style&index=0&id=14ed6709&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ed6709"]])

export default __exports__